import React, { createContext, useContext } from "react"
import { Empty, Flex, Result } from "antd"

import { EnumTipoUsuario } from "../../../../Models/Domain/AreaRestrita/Sessao"
import { SessaoARContext } from "../../../Contexts/SessaoContext"
import { ComParametrosDaSessaoDaEscola, ParametrosDaSessaoDaEscola } from "./ParametrosDaEscola"
import { ComParametrosDaSessaoDoAluno, ParametrosDaSessaoDoAluno } from "./ParametrosDoAluno"
import { ComParametrosDaSessaoDoResponsavel, ParametrosDaSessaoDoResponsavel } from "./ParametrosDoResponsavel"
import ContateOSuporte from "../../../../Components/ContateOSuporte"

type ParametrosDaSessaoAR = (
    | null | ParametrosDaSessaoDoResponsavel | ParametrosDaSessaoDaEscola | ParametrosDaSessaoDoAluno
);

export type { ParametrosDaSessaoDoResponsavel, ParametrosDaSessaoDaEscola, ParametrosDaSessaoDoAluno, ParametrosDaSessaoAR }

export const ParametrosDaSessaoARContext = createContext<ParametrosDaSessaoAR>(null);

/**
 * Age como uma camada extra para a apresentação das telas, com adição de regras de controle de fluxo. 
 */
export const ComParametrosDaSessao: React.FC<{
    children: React.ReactNode
}> = (props) => {
    const SessaoAR = useContext(SessaoARContext);
    const tipoDeUsuario = SessaoAR?.sessao?.tipoDeUsuario;

    if(tipoDeUsuario == EnumTipoUsuario.Responsavel){
        return <React.Fragment>
            <ComParametrosDaSessaoDoResponsavel>
            {props.children}
            </ComParametrosDaSessaoDoResponsavel>
        </React.Fragment>
    } 

    if (tipoDeUsuario == EnumTipoUsuario.Escola){
        return <React.Fragment>
            <ComParametrosDaSessaoDaEscola>
                {props.children}
            </ComParametrosDaSessaoDaEscola>
        </React.Fragment>
    }

    if (tipoDeUsuario == EnumTipoUsuario.Aluno) {
        return (
            <React.Fragment>
                <ComParametrosDaSessaoDoAluno>{props.children}</ComParametrosDaSessaoDoAluno>
            </React.Fragment>
        );
    }

    return (
        <Flex style={{ height: "100%" }} align="center" justify="center">
            <ContateOSuporte codigo="bd645de9"/>
        </Flex>
    );
}